import {put} from 'redux-saga/effects';
import {GET_PLAYERS} from "../../constants/PlayerConstants";


export function* setSettingSaga(): Generator {
    yield put({type: GET_PLAYERS});
}
